<template>
  <svg
    id="icon-plus"
    xmlns="http://www.w3.org/2000/svg"
    :width="width"
    :height="height"
    fill="none"
    viewBox="0 0 11 10"
  >
    <path
      :fill="fill"
      d="M4.556 9.562V.439h1.815v9.123H4.556ZM.906 5.905V4.09h9.122v1.815H.906Z"
    />
  </svg>
</template>

<script>
import { iconPropsFunc } from "./mixins/icons";

export default {
  name: "IconPlus",
  mixins: [iconPropsFunc()],
};
</script>

<style lang="scss" scoped></style>
